module.exports = __webpack_public_path__ + "static/media/uc_logo.91583110.png";